"use client";

import dynamic from "next/dynamic";

/** Matches fixed `AsciiVideoCanvasBackground` shell so layout paints before the chunk loads. */
function FixedModeLoading() {
  return (
    <div
      className="pointer-events-none fixed inset-0 z-[1] overflow-hidden bg-tan dark:bg-background-dark"
      aria-hidden
    />
  );
}

function ContainedModeLoading() {
  return (
    <div
      className="pointer-events-none absolute inset-0 z-[1] overflow-hidden bg-tan dark:bg-background-dark"
      aria-hidden
    />
  );
}

export const LazyAsciiVideoCanvasBackgroundFixed = dynamic(
  () => import("@/components/animations/AsciiVideoCanvasBackground"),
  { ssr: false, loading: FixedModeLoading },
);

export const LazyAsciiVideoCanvasBackgroundContained = dynamic(
  () => import("@/components/animations/AsciiVideoCanvasBackground"),
  { ssr: false, loading: ContainedModeLoading },
);
